<template>
    <div style="background: #FFFFFF;min-height:calc(100vh - 110px);">
      <div class="accountView">
        <usp-tabs v-model="activeIndex" @tab-click="handleSelect">
          <usp-tab-pane label="我的文章" class="usp-tab-pane-tittle" name="my" bottom-line-width="16">
          </usp-tab-pane>
          <usp-tab-pane label="我的收藏" class="usp-tab-pane-tittle" name="collection" bottom-line-width="16">
          </usp-tab-pane>
          <usp-tab-pane label="我的回复" class="usp-tab-pane-tittle" name="reply" bottom-line-width="16">
          </usp-tab-pane>
          <usp-tab-pane label="我的评论" class="usp-tab-pane-tittle" name="comment" bottom-line-width="16">
          </usp-tab-pane>
        </usp-tabs>

        <div v-show="list.length > 0" style="width: 100%">
          <div
              v-for="(item, index) in list"
              :key="'list' + index"
              class="item-tittle-div" >
            <div v-if="activeIndex === 'comment'" >
              <div class="item-tittle" @click="toCommentDetail(item.id, item.targetId)">
                <div class="reply-div-answer" v-html="item.content"></div>
              </div>
              <div class="item-div">
                <div class="item-author-div">
                  <img class="item-headPortrait" :src="!item.headPortrait || item.headPortrait === ''? require('@/assets/img/forum/forum_user.png') : item.headPortrait" alt="">
                  <div class="item-userName">{{item.nickName}}</div>
                  <div class="item-publishTime">{{timeFormatSeconds(item.publishTime)}}</div>
                </div>
              </div>
            </div>
            <div v-else-if="activeIndex === 'reply'" >
             <div class="item-tittle" @click="toReplyDetail(item.id, item.targetId)">
                <div class="reply-div-answer" v-html="item.content"></div>
              </div>
              <div class="item-div">
                <div class="item-author-div">
                  <img class="item-headPortrait" :src="!item.headPortrait || item.headPortrait === ''? require('@/assets/img/forum/forum_user.png') : item.headPortrait" alt="">
                  <div class="item-userName">{{item.nickName}}</div>
                  <div class="item-publishTime">{{timeFormatSeconds(item.publishTime)}}</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="item-tittle" @click="toDetail(item.id)">
                {{item.title}}
                <div class="tab1">{{showChannel(item.channelIds[0])}}</div>
                <div v-for="(tagItem, tagIndex) in item.tags" :key="'tag' + tagIndex" class="tab">{{tagItem}}</div>
              </div>
              <div class="item-div">
                <div class="item-author-div">
                  <img class="item-headPortrait" :src="!item.headPortrait || item.headPortrait === ''? require('@/assets/img/forum/forum_user.png') : item.headPortrait" alt="">
                  <div class="item-userName">{{item.author}}</div>
                  <div class="item-publishTime">{{timeFormatSeconds(item.publishTime)}}</div>
                </div>
                <div class="item-num-div">
                  <div class="item-num-div-div">
                    <i class="el-icon-view" style="color: #2F374B;font-size: 24px;margin-right: 2px"></i>
                    <span class="item-num">{{item.views}}</span>
                  </div>
                  <div class="item-num-div-div">
                    <img src="@/assets/icons/like.svg" style="width: 24px;height: 24px;margin-right: 2px" alt="">
                    <span class="item-num">{{item.thumbs}}</span>
                  </div>
                  <div class="item-num-div-div">
                    <i class="el-icon-chat-dot-round" style="color: #2F374B;font-size: 24px;margin-right: 2px"></i>
                    <span class="item-num">{{item.comment}}</span>
                  </div>
                  <div v-if="activeIndex === 'collection'">
                    <button class="cancelCollection" @click="collection(item.id)">
                      取消收藏
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="list.length < 1" style="width: 100%;text-align: center;padding: 20px;box-sizing: border-box">
          <img src="@/assets/img/pages/nodata.png" style="height: 250px;" alt="">
        </div>
        <div class="pagination">
          <el-pagination
              background
              :hide-on-single-page="true"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, total, jumper"
              :total="total"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
</template>
<script>

import { findPage, findTarget, channelFindAll, collection, commentFindPage } from '@/api/modules/myForum'
import UspTabPane from '@/components/uaesTabs/tab-pane'
import UspTabs from '@/components/uaesTabs/tabs'
import { timeFormatSeconds } from '@/scripts/dataTimeUtils'
export default {
  components: {
    UspTabPane,
    UspTabs
  },
  data() {
    return {
      activeIndex: 'my',
      userInfo: {},
      list: [],
      total: '',
      currentPage: 1,
      pageSize: 10,
      channelList: []
    }
  },
  async created() {
    const user = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    this.userInfo = user
    this.getList()
    this.channelFind()
  },
  methods: {
    handleSelect(e) {
      this.currentPage = 1
      this.pageSize = 10
      this.activeIndex = e.name
      this.getList()
    },
    async channelFind() {
      const data = {}
      const res = await channelFindAll(data)
      if (res.code === 0) {
        this.channelList = res.data
      }
    },
    async getList() {
      let res
      if (this.activeIndex === 'my') {
        res = await findPage({
          authorId: this.userInfo.id
        }, this.currentPage, this.pageSize)
      }
      else if (this.activeIndex === 'collection') {
        res = await findTarget({
          userId: this.userInfo.id,
          targetType: 'article'
        }, this.currentPage, this.pageSize)
      }
      else if (this.activeIndex === 'reply') {
        res = await commentFindPage({
          userId: this.userInfo.id,
          targetType: 'article'
        }, this.currentPage, this.pageSize)
      }
      else if (this.activeIndex === 'comment') {
        res = await commentFindPage({
          userId: this.userInfo.id,
          targetType: 'comment'
        }, this.currentPage, this.pageSize)
      }
      if (res.code === 0) {
        this.list = res.data
        this.total = res.total
        console.log(this.list)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    showChannel(id) {
      if (id) {
        const data = this.channelList.filter((channel) => {
          return channel.id === id
        })
        if (data[0] && data[0].name) {
          return data[0].name
        }
        else {
          return '删除的频道'
        }
      }
      else {
        return '删除的频道'
      }
    },
    toDetail(id) {
      this.$router.push({ path: '/forum/detail', query: { id: id }})
    },
    timeFormatSeconds(time) {
      return timeFormatSeconds(time)
    },
    collection(id) {
      const that = this
      this.$confirm('是否取消当前收藏?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.cancelCollectionClick(id)
      }).catch(() => {
      })
    },
    async cancelCollectionClick(id) {
      const res = await collection({ targetId: id, targetType: 'article', userId: this.userInfo.id })
      if (res.code === 0) {
        this.$message({
          message: '取消收藏成功',
          type: 'success',
          offset: 100
        })
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    handleCurrentChange() {
      this.getList()
    },
    toReplyDetail(id, targetId) {
      this.$router.push({ path: '/forum/replyDetail', query: { id: id, targetId: targetId }})
    },
    toCommentDetail(id, targetId) {
      this.$router.push({ path: '/forum/commentDetail', query: { id: id, targetId: targetId }})
    }
  }
}
</script>
<style lang="less" scoped>
.accountView {
  padding: 26px 34px;
  height: 100%;
}
::v-deep .el-tabs__nav-wrap::after {
  background:none;
}
/deep/ .el-tabs__item {
  font-size: 18px !important;
}
/deep/ .el-tabs__active-bar {
  height: 4px;
}
.item-tittle-div {
  border-bottom: 1px solid #DDDDDD;
  padding: 20px 0px;
  box-sizing: border-box;
}
.item-tittle {
  font-size: 20px;
  font-weight: 400;
  color: #2F374B;
  line-height: 46px;
  cursor: pointer;
}
.tab1{
  display: inline-block;
  border: 1px solid #EFA13E;
  border-radius: 12px;
  color: #EFA13E;
  min-width: 52px;
  font-size: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 7px;
  cursor: default;
  background-color: #FEF7EE;
}
.item-div {
  height: 50%;
  padding-top: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between
}
.item-author-div {
  width: 600px;
  display: flex;
  align-items: center;
  align-items: center;
  align-content: center;
}
.item-headPortrait {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.item-userName {
  padding-left: 12px;
  font-size: 14px;
  font-weight: 400;
  color: #2F374B;
}
.item-publishTime {
  padding-left: 46px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.item-num-div {
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: space-between
}
.item-num-div-div {
  align-items: center;
  display: flex;
}
.item-num-div-div + .item-num-div-div{
  margin-left: 52px;
}
.item-num{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2F374B;
  line-height: 46px;
  width: 20px;
}
.cancelCollection{
  width: 96px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #4D78FF;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #4D78FF;
  margin-left: 52px;
  cursor: pointer;
}
.comment-div{
  min-height: 55px;
  background: #F8F8F8;
  border-radius: 4px;
  margin-top: 15px;
  display: flex;
  padding: 0 20px;
}
.comment-div-myName{
  font-size: 18px;
  font-weight: 500;
  color: #2F374B;
  display: flex;
  align-self: center;
  align-items: center;
}
.comment-div-answer{
  font-size: 20px;
  font-weight: 400;
  color: #2F374B;
  //display: flex;
  align-self: center;
  padding-left: 38px;
}
.reply-div-answer {
  font-size: 20px;
  font-weight: 400;
  color: #2F374B;
  align-self: center;
}
/deep/.reply-div-answer > p > img {
  max-height: 30px;
  margin: auto 10px;
}
/deep/.reply-div-answer > p {
  margin: 0px;
}
.pagination {
  padding: 28px 0;
  text-align: right;
}
.tab{
  display: inline-block;
  border: 1px solid #59C264;
  border-radius: 12px;
  color: #59C264;
  min-width: 52px;
  font-size: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 7px;
  cursor: default;
  background-color: #F0FFF2;
}
</style>
